import { isValidElement, useState } from 'react';
import { Modal, Checkbox } from 'antd';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { CustomIcon } from '$src/components/CustomIcon';
import './index.less';

function ShowAgain({ dontShowAgain, setDontShowAgain }) {
  return (
    <>
      <hr />
      <Checkbox checked={dontShowAgain} onChange={() => setDontShowAgain(!dontShowAgain)}>
        Don’t show this again
      </Checkbox>
      <hr />
    </>
  );
}

ShowAgain.propTypes = {
  dontShowAgain: PropTypes.bool,
  setDontShowAgain: PropTypes.func,
};

function ModalCustom({
  contentMessage,
  contentTitle,
  handleCancel,
  primaryActionOnCross,
  handleOk,
  icon,
  loadingButton,
  title,
  visible,
  setModalVisible,
  danger,
  okText,
  imgHeader,
  enableShowAgain,
  showAgainStorageKey,
  cancelOnX,
  ...rest
}) {
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const dontShowAgainStoredSelection = enableShowAgain && localStorage?.getItem(showAgainStorageKey);
  if (dontShowAgainStoredSelection && visible) {
    handleOk();
    return null;
  }
  const checkDontShowAgainHandler = () => {
    if (dontShowAgain) {
      localStorage?.setItem(showAgainStorageKey, true);
    } else {
      localStorage?.removeItem(showAgainStorageKey);
    }
  };

  return (
    <Modal
      className={cx('modal-wrapper', { 'modal-wrapper--img': imgHeader })}
      title={title ?? <img src={imgHeader} />}
      open={visible}
      onOk={() => {
        checkDontShowAgainHandler();
        handleOk();
      }}
      onCancel={(event) => {
        if (handleCancel && (event.currentTarget.id === 'cancel-button' || cancelOnX)) {
          handleCancel();
        }
        if (enableShowAgain) setDontShowAgain(false);
        setModalVisible(false);
      }}
      okText={okText}
      cancelButtonProps={{
        className: 'ring-button',
        disabled: loadingButton,
        danger,
        id: 'cancel-button',
        'data-testid': 'cancel-button',
      }}
      okButtonProps={{
        loading: loadingButton,
        danger,
        id: 'ok-button',
        'data-testid': 'ok-button',
      }}
      {...rest}
    >
      {icon && <CustomIcon name={icon} type="regular" className={cx('modalIcon', { 'modalIcon--danger': danger })} />}
      <h1>{contentTitle}</h1>
      {isValidElement(contentMessage) ? contentMessage : <p> {contentMessage} </p>}
      {enableShowAgain && <ShowAgain dontShowAgain={dontShowAgain} setDontShowAgain={setDontShowAgain} />}
    </Modal>
  );
}

ModalCustom.propTypes = {
  handleCancel: PropTypes.func,
  setModalVisible: PropTypes.func,
  handleOk: PropTypes.func,
  contentMessage: PropTypes.node,
  contentTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  danger: PropTypes.bool,
  primaryActionOnCross: PropTypes.bool,
  icon: PropTypes.string,
  loadingButton: PropTypes.bool,
  okText: PropTypes.node,
  title: PropTypes.string,
  visible: PropTypes.bool,
  imgHeader: PropTypes.string,
  enableShowAgain: PropTypes.bool,
  showAgainStorageKey: PropTypes.string,
  cancelOnX: PropTypes.bool,
};

ModalCustom.defaultProps = {
  okText: 'Reset Preferences',
  danger: false,
  enableShowAgain: false,
  primaryActionOnCross: false,
};

export { ModalCustom };
